"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sumSweepstakesPrizeValues = exports.getSweepstakesPrizeValueRestriction = exports.SWEEPSTAKES_PRIZE_VALUE_LIMIT = exports.hasForbiddenSweepstakesWording = exports.getSweepstakesFreeEntryCount = exports.SweepstakesFreeEntryRuleVersion = exports.formatSweepstakesEntryLevels = exports.getSweepstakesSponsorEntityType = exports.getSweepstakesSponsorTaxIdLabel = exports.getSweepstakesEligibleTerritory = exports.getSweepstakesCountryName = exports.isSweepstakesBaseEntryRateRequired = exports.getSweepstakesRulesKind = exports.shouldShowUsLotteryDisclosures = exports.isSweepstakesCountry = void 0;
const common_1 = require("../../enums/common");
const country_1 = require("../enums/country");
const display_1 = require("../region/display");
const resolve_1 = require("../region/resolve");
const isSweepstakesCountry = (country) => country === country_1.OrganizationCountry.UnitedStates ||
    country === country_1.OrganizationCountry.GreatBritain ||
    country === country_1.OrganizationCountry.Canada;
exports.isSweepstakesCountry = isSweepstakesCountry;
const shouldShowUsLotteryDisclosures = (country) => country === country_1.OrganizationCountry.UnitedStates;
exports.shouldShowUsLotteryDisclosures = shouldShowUsLotteryDisclosures;
const getSweepstakesRulesKind = (country) => {
    if (country === country_1.OrganizationCountry.GreatBritain) {
        return "ukFreePrizeDraw";
    }
    if (country === country_1.OrganizationCountry.Canada) {
        return "canadaContest";
    }
    return "usSweepstakes";
};
exports.getSweepstakesRulesKind = getSweepstakesRulesKind;
const isSweepstakesBaseEntryRateRequired = (country, organizationType) => country !== country_1.OrganizationCountry.UnitedStates || organizationType !== common_1.OrganizationType.Charity;
exports.isSweepstakesBaseEntryRateRequired = isSweepstakesBaseEntryRateRequired;
const SWEEPSTAKES_COUNTRY_NAME = {
    [country_1.OrganizationCountry.Canada]: "Canada",
    [country_1.OrganizationCountry.UnitedStates]: "United States",
    [country_1.OrganizationCountry.GreatBritain]: "United Kingdom",
    [country_1.OrganizationCountry.Australia]: "Australia",
    [country_1.OrganizationCountry.NewZealand]: "New Zealand",
    [country_1.OrganizationCountry.Ireland]: "Ireland",
    [country_1.OrganizationCountry.Germany]: "Germany",
};
const getSweepstakesCountryName = (country) => country ? SWEEPSTAKES_COUNTRY_NAME[country] : null;
exports.getSweepstakesCountryName = getSweepstakesCountryName;
const getSweepstakesEligibleTerritory = (country) => {
    if (country === country_1.OrganizationCountry.UnitedStates) {
        return "the fifty (50) United States and the District of Columbia";
    }
    const countryName = (0, exports.getSweepstakesCountryName)(country);
    return countryName && country === country_1.OrganizationCountry.GreatBritain ? `the ${countryName}` : countryName;
};
exports.getSweepstakesEligibleTerritory = getSweepstakesEligibleTerritory;
const getSweepstakesSponsorTaxIdLabel = (country, type) => {
    if (country === country_1.OrganizationCountry.UnitedStates) {
        return "EIN";
    }
    return type === common_1.OrganizationType.Charity ? "registered charity number" : "registration number";
};
exports.getSweepstakesSponsorTaxIdLabel = getSweepstakesSponsorTaxIdLabel;
const getSweepstakesSponsorEntityType = (country, type) => {
    switch (type) {
        case common_1.OrganizationType.Charity:
            return country === country_1.OrganizationCountry.UnitedStates
                ? "a 501(c)(3) nonprofit organization"
                : "a registered charity";
        case common_1.OrganizationType.Other501C:
            return "a 501(c) tax-exempt organization";
        case common_1.OrganizationType.Social:
            return "a nonprofit social enterprise";
        case common_1.OrganizationType.Private:
            return "a private business";
        default:
            return null;
    }
};
exports.getSweepstakesSponsorEntityType = getSweepstakesSponsorEntityType;
const formatSweepstakesEntryLevels = (levels) => levels
    .map(({ title, entryCount, formattedAmount }) => {
    const count = entryCount && entryCount > 0 ? entryCount : 1;
    const level = `${count} ${count === 1 ? "entry" : "entries"} for ${formattedAmount}`;
    return title ? `${title}: ${level}` : level;
})
    .join("\n") || null;
exports.formatSweepstakesEntryLevels = formatSweepstakesEntryLevels;
var SweepstakesFreeEntryRuleVersion;
(function (SweepstakesFreeEntryRuleVersion) {
    SweepstakesFreeEntryRuleVersion[SweepstakesFreeEntryRuleVersion["SmallestBundle"] = 1] = "SmallestBundle";
    SweepstakesFreeEntryRuleVersion[SweepstakesFreeEntryRuleVersion["ShareOfBiggestBundle"] = 2] = "ShareOfBiggestBundle";
})(SweepstakesFreeEntryRuleVersion || (exports.SweepstakesFreeEntryRuleVersion = SweepstakesFreeEntryRuleVersion = {}));
const SWEEPSTAKES_FREE_ENTRY_PERCENT_OF_BIGGEST_BUNDLE = 5;
const getSweepstakesFreeEntryCount = (rates, { ruleVersion }) => {
    const bundleEntryCounts = rates
        .map(({ attendeesByTicket }) => attendeesByTicket ?? 1)
        .filter((entryCount) => entryCount > 1);
    if (bundleEntryCounts.length === 0) {
        return 1;
    }
    const smallestBundle = Math.min(...bundleEntryCounts);
    if (ruleVersion === SweepstakesFreeEntryRuleVersion.SmallestBundle) {
        return smallestBundle;
    }
    const shareOfBiggestBundle = Math.ceil((Math.max(...bundleEntryCounts) * SWEEPSTAKES_FREE_ENTRY_PERCENT_OF_BIGGEST_BUNDLE) / 100);
    return Math.min(smallestBundle, Math.max(1, shareOfBiggestBundle));
};
exports.getSweepstakesFreeEntryCount = getSweepstakesFreeEntryCount;
const hasForbiddenSweepstakesWording = (text) => /\braffles?\b/i.test(text ?? "");
exports.hasForbiddenSweepstakesWording = hasForbiddenSweepstakesWording;
exports.SWEEPSTAKES_PRIZE_VALUE_LIMIT = 500_000;
const SWEEPSTAKES_PRIZE_LIMIT_EXEMPT_TYPES_BY_REGION = {
    NY: [common_1.OrganizationType.Charity],
    FL: [common_1.OrganizationType.Charity, common_1.OrganizationType.Other501C],
};
const getSweepstakesPrizeValueRestriction = ({ country, region, organizationType, totalPrizeValue, }) => {
    if (country !== country_1.OrganizationCountry.UnitedStates || totalPrizeValue <= exports.SWEEPSTAKES_PRIZE_VALUE_LIMIT) {
        return { isRestricted: false, regionName: null };
    }
    const regionCode = (0, resolve_1.resolveRegionCode)(country, region);
    const exemptTypes = regionCode ? SWEEPSTAKES_PRIZE_LIMIT_EXEMPT_TYPES_BY_REGION[regionCode] : undefined;
    if (!regionCode || !exemptTypes || (organizationType && exemptTypes.includes(organizationType))) {
        return { isRestricted: false, regionName: null };
    }
    return { isRestricted: true, regionName: (0, display_1.getRegionDisplayName)(country, regionCode) };
};
exports.getSweepstakesPrizeValueRestriction = getSweepstakesPrizeValueRestriction;
const sumSweepstakesPrizeValues = (prizes) => prizes.reduce((total, prize) => total + (prize.value ?? 0), 0);
exports.sumSweepstakesPrizeValues = sumSweepstakesPrizeValues;
